import { IApplicationState } from '../../types/redux';

export function selectRecommendations(state: IApplicationState) {
  return state.recommendations.data;
}

export const selectRecommendationById = (id: number) => (state: IApplicationState) =>
  state.recommendations.data.find(({ offerId }) => offerId === id);

export function selectRecommendationsStatus(state: IApplicationState) {
  return state.recommendations.status;
}

export function selectHasMore(state: IApplicationState) {
  return state.recommendations.hasMore;
}

export function selectPaginationStatus(state: IApplicationState) {
  return state.recommendations.paginationStatus;
}
